export default __webpack_public_path__ + "static/media/kyc-selfie-illustration-good-zh.1a3eb209.svg";